import { Dispatch, ThunkAction } from '../../../types/actions';
import { EUserSettingsVideoVoice } from '../../../types/rest/IRestAuthUser';
import { IGetState } from '../../../types/types';
import { authUserPatch } from './api/helper/authUserPatch';
import { getAuthUser } from '../../../store/model/authUser/selectors/getAuthUser';

export const authUserSetVideoVoice = (
    videoVoice: EUserSettingsVideoVoice
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        const state = getState();
        const authUser = getAuthUser(state);
        const userPatch = {
            id: authUser.id,
            settings: {
                ...authUser.settings,
                videoVoice
    }
    };
        return dispatch(authUserPatch(userPatch));
    };
    return action;
};
